<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form" validate-on="invalid-input">
                <custom-divider label="تنظیمات پایه"></custom-divider>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان سامانه"
                    v-model="form.system_title"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    label="آدرس ایمیل / آدرس صفحه ارتباط با ما"
                    v-model="form.system_email"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    label="شماره تماس"
                    v-model="form.system_phone"
                ></v-text-field>
                <file-input
                    :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span class='font-weight-medium'>فایل لوگوی بزرگ روشن</span><span class='d-block'>فرمت: png | ابعاد: 40 * 170 | سایز فایل: 500KB</span></div>`"
                    :style="{backgroundColor: '#e7e7e7', borderRadius: '4px', height: '70px'}"
                    :types="['png']"
                    :mimeTypes="['image/png']"
                    :size="512000"
                    type="image"
                    imageSize="auto"
                    ref="logoInput"
                    @updated="logoChanged"
                ></file-input>
                <file-input
                    :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span class='font-weight-medium'>فایل لوگوی بزرگ تیره</span><span class='d-block'>فرمت: png | ابعاد: 40 * 170 | سایز فایل: 500KB</span></div>`"
                    :style="{backgroundColor: '#e7e7e7', borderRadius: '4px', height: '70px'}"
                    :types="['png']"
                    :mimeTypes="['image/png']"
                    :size="512000"
                    type="image"
                    imageSize="auto"
                    ref="darkLogoInput"
                    class="mt-4"
                    @updated="darkLogoChanged"
                ></file-input>
                <v-row class="my-2" justify="space-around">
                    <v-col cols="auto">
                        <div style="width:9.375rem; height:9.375rem">
                            <file-input
                                :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span class='font-weight-medium'>فایل لوگوی کوچک</span><span class='d-block'>فرمت: png</span><span class='d-block mt-n1'>ابعاد: 50 * 50</span><span class='d-block mt-n1'>سایز فایل: 500KB</span></div>`"
                                :style="{backgroundColor: '#e7e7e7', borderRadius: '4px'}"
                                :types="['png']"
                                :mimeTypes="['image/png']"
                                :size="512000"
                                type="image"
                                imageSize="fill"
                                ref="smallLogoInput"
                                @updated="smallLogoChanged"
                            ></file-input>
                        </div>
                    </v-col>
                    <v-col cols="auto">
                        <div style="width:9.375rem !important; height:9.375rem !important">
                            <file-input
                                :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span class='font-weight-medium'>فایل Favicon</span><span class='d-block'>فرمت: png</span><span class='d-block mt-n1'>ابعاد: 32 * 32</span><span class='d-block mt-n1'>سایز فایل: 500KB</span></div>`"
                                :style="{backgroundColor: '#e7e7e7', borderRadius: '4px'}"
                                :types="['png']"
                                :mimeTypes="['image/png']"
                                :size="512000"
                                type="image"
                                imageSize="fill"
                                ref="faviconInput"
                                @updated="faviconChanged"
                            ></file-input>
                        </div>
                    </v-col>
                </v-row>
                <v-text-field
                    :rules="$validation('url')"
                    label="لینک ارجاع از لوگو"
                    ref="logoLink"
                    v-model="form.logo_link"
                ></v-text-field>
                <custom-divider label="تنظیمات Widget"></custom-divider>
                <v-row align="center">
                    <v-col cols="6">
                        <v-menu
                            :close-on-content-click="false"
                            content-class="sidebar-items"
                            location="left"
                            z-index="10"
                            max-width="300"
                            v-model="colorMenu"
                        >
                            <template #activator="{ props }">
                                <v-text-field
                                    dir="ltr"
                                    type="button"
                                    :model-value="widget.color.substr(0,7)"
                                    v-bind="props"
                                    @click="colorMenu = true"
                                    class="arial-input"
                                    label="انتخاب رنگ"
                                    hide-details
                                    @update:modelValue="$refs.floatingButton.removeWidget()"
                                >
                                    <template #append-inner>
                                        <v-icon :color="widget.color">circle</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-color-picker
                                class="settings-knowledgebaseSettings-colorPicker arial-input"
                                dot-size="15"
                                swatches-max-height="200"
                                v-model="widget.color"
                                mode="hexa"
                            ></v-color-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6">
                        <v-select
                            :items="[{name:'راست', value:'right'},{name:'چپ', value:'left'}]"
                            hide-details
                            item-title="name"
                            item-value="value"
                            label="محل قرارگیری"
                            no-data-text="موردی پیدا نشد!"
                            v-model="widget.side"
                            @update:modelValue="$refs.floatingButton.removeWidget()"
                        ></v-select>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            hide-details
                            label="فاصله از پایین"
                            prefix="px"
                            v-model="widget.bottom"
                            @update:modelValue="$refs.floatingButton.removeWidget()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            hide-details
                            :label="`فاصله از ${widget.side == 'right' ? 'راست' : 'چپ'}`"
                            prefix="px"
                            v-model="widget.sidePx"
                            @update:modelValue="$refs.floatingButton.removeWidget()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-btn block color="grey-lighten-3" @click="$refs.floatingButton.generateWidget()">پیش نمایش</v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn block color="grey-lighten-3" @click="()=>{floatingButtonScript = $refs.floatingButton.getScript(); $text.copy(floatingButtonScript)}">ایجاد و کپی اسکریپت</v-btn>
                    </v-col>
                    <v-col cols="12">
                        <div style="height: 160px; border: 1px solid #aaa; overflow-y: auto; scrollbar-width: thin" dir="ltr" class="rounded px-2 py-1 mb-5 text-meta">{{ floatingButtonScript }}</div>
                    </v-col>
                </v-row>
                <custom-divider label="تنظیمات تعلیق سامانه"></custom-divider>
                <switch-input v-model="form.system_suspension" label="وضعیت" tooltip="با فعال‌سازی وضعیت تعلیق، تنها مدیر ارشد امکان ورود به سامانه را دارد."></switch-input>
                <v-textarea
                    :rules="$validation()"
                    label="پیغام وضعیت تعلیق"
                    no-resize
                    rows="3"
                    v-model="form.system_suspension_message"
                ></v-textarea>
                <custom-divider label="تنظیمات فایل‌های پیوست"></custom-divider>
                <v-select
                    :items="attachmentSizeList"
                    label="حجم مجاز"
                    no-data-text="موردی پیدا نشد!"
                    v-model="form.attachments_maximum_size"
                ></v-select>
                <v-select
                    :items="attachmentTypeList"
                    label="پسوندهای مجاز"
                    no-data-text="موردی پیدا نشد!"
                    multiple
                    v-model="form.attachments_allowed_types"
                >
                    <template #prepend-item>
                        <toggle-select-all @clicked="$text.toggleSelectAll('form.attachments_allowed_types' , 'attachmentTypeList', $data, false)" :items='form.attachments_allowed_types' :all='attachmentTypeList'></toggle-select-all>
                    </template>
                </v-select>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn @click="$router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
                </div>
            </v-form>
        </v-col>
        <floating-action-button :items="{...widget, email: form.system_email, phone: form.system_phone}" ref="floatingButton"></floating-action-button>
    </div>
</template>

<script>
export default {
    title: "اطلاعات سامانه",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            colorMenu: false,
            widget:{
                bottom: this.$system.settings.widget?.bottom ?? 40,
                sidePx: this.$system.settings.widget?.sidePx ?? 40,
                side: this.$system.settings.widget?.side ?? 'right',
                color: this.$system.settings.widget?.color ?? '#548246',
            },
            floatingButtonScript: null,
            attachmentSizeList: ["100KB", "250KB", "500KB", "1MB", "2MB", "5MB", "10MB", "25MB", "50MB", "100MB"],
            attachmentTypeList: Object.keys(this.$system.mimeTypes),
            form: {
                system_title: this.$system.settings.system_title,
                system_email: this.$system.settings.system_email,
                system_phone: this.$system.settings.system_phone,
                logo_link: this.$system.settings.logo_link,
                system_suspension: this.$system.settings.system_suspension,
                system_suspension_message: this.$system.settings.system_suspension_message,
                attachments_maximum_size: this.$system.settings.attachments_maximum_size,
                attachments_allowed_types: [...this.$system.settings.attachments_allowed_types],
            },
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$updateSettings(this.$object.toFormData({...this.form, widget: this.widget, _method: 'put'})).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setGlobalSettings(true);
                    this.$system.setSystemSettings(true);
                }
            }).finally(()=>{this.loading = false});
        },
        logoChanged() {
            let file = this.$refs.logoInput.getValidFiles();
            this.form.logo_name = file == null ? 'unset' : file['file'];
        },
        darkLogoChanged() {
            let file = this.$refs.darkLogoInput.getValidFiles();
            this.form.dark_logo_name = file == null ? 'unset' : file['file'];
        },
        smallLogoChanged() {
            let file = this.$refs.smallLogoInput.getValidFiles();
            this.form.small_logo_name = file == null ? 'unset' : file['file'];
        },
        faviconChanged() {
            let file = this.$refs.faviconInput.getValidFiles();
            this.form.favicon_name = file == null ? 'unset' : file['file'];
        },
    },
    mounted() {
        if(this.$system.settings.logo_name)
            this.$refs.logoInput.setImageFileFromServer(this.$system.settings.logo_name);
        if(this.$system.settings.dark_logo_name)
            this.$refs.darkLogoInput.setImageFileFromServer(this.$system.settings.dark_logo_name);
        if(this.$system.settings.small_logo_name)
            this.$refs.smallLogoInput.setImageFileFromServer(this.$system.settings.small_logo_name);
        if(this.$system.settings.favicon_name)
            this.$refs.faviconInput.setImageFileFromServer(this.$system.settings.favicon_name);
    },
};
</script>
